export const UPLOAD_IMG_ACCEPT = "image/png,image/jpeg,image/jpg,image/gif"

export const HOME_URL = "/main/home"
